import styled, { css } from 'styled-components';

import variables from '../../../../styles/variables';

interface IndexProps {
  readonly $index?: number;
}

export const Wrapper = styled.section<IndexProps>`
  width: 100%;
  margin: 40px auto;
  
  ${({ $index }) => ($index === 0
      && css`
        margin: 0 auto 40px;
  `)}
`;

export const Container = styled.div`
  width: 100%;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;
  margin: 0 auto;

  @media screen and (max-width: 1023px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
`;
